import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Divider,
  Paper,
} from '@mui/material';
import {
  AdminPanelSettings,
  Link as LinkIcon,
  Info,
} from '@mui/icons-material';

const IndexPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, md: 3 } }}>
      <Box textAlign="center" mb={{ xs: 4, md: 6 }}>
        <img 
          src="https://images.bsmmupathalumni.org/BPDAA.png" 
          alt="BSMMUPATHALUMNI Logo" 
          style={{ 
            width: '80px', 
            height: 'auto', 
            marginBottom: '16px',
            maxWidth: '100%'
          }} 
        />
        <Typography 
          variant="h3" 
          component="h1" 
          gutterBottom 
          fontWeight="bold"
          sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem' } }}
        >
          BSMMUPATHALUMNI
        </Typography>
        <Typography 
          variant="h6" 
          color="text.secondary" 
          paragraph
          sx={{ fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' } }}
        >
          Alumni Registration & Form Management System
        </Typography>
      </Box>

      <Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, mb: 4, backgroundColor: '#f8f9fa' }}>
        <Box textAlign="center">
          <Info sx={{ fontSize: { xs: 32, md: 40 }, color: 'info.main', mb: 2 }} />
          <Typography 
            variant="h5" 
            gutterBottom 
            color="text.primary"
            sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' } }}
          >
            Welcome to BSMMUPATHALUMNI Portal
          </Typography>
          <Typography 
            variant="body1" 
            color="text.secondary" 
            paragraph
            sx={{ fontSize: { xs: '0.875rem', md: '1rem' } }}
          >
            It looks like you've found your way to our main portal. This system is designed for 
            BSMMUPATHALUMNI members to access specific forms and services.
          </Typography>
        </Box>
      </Paper>

      <Stack spacing={{ xs: 2, md: 3 }}>
        {/* Admin Login Card */}
        <Card elevation={3}>
          <CardContent sx={{ p: { xs: 2, md: 3 } }}>
            <Box display="flex" alignItems="center" mb={2} flexDirection={{ xs: 'column', sm: 'row' }}>
              <AdminPanelSettings sx={{ mr: { xs: 0, sm: 2 }, mb: { xs: 1, sm: 0 }, color: 'primary.main' }} />
              <Typography 
                variant="h6" 
                component="h2"
                sx={{ fontSize: { xs: '1.125rem', md: '1.25rem' } }}
              >
                Administrative Access
              </Typography>
            </Box>
            <Typography 
              variant="body2" 
              color="text.secondary" 
              paragraph
              sx={{ fontSize: { xs: '0.875rem', md: '0.875rem' } }}
            >
              If you're an administrator, you can access the admin panel to manage forms, 
              submissions, and system settings.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate('/login')}
              startIcon={<AdminPanelSettings />}
              fullWidth
              sx={{ 
                py: { xs: 1.5, md: 1 },
                fontSize: { xs: '0.875rem', md: '0.875rem' }
              }}
            >
              Admin Login
            </Button>
          </CardContent>
        </Card>

        <Divider sx={{ my: { xs: 1, md: 2 } }} />

        {/* For Alumni/Users */}
        <Card elevation={3}>
          <CardContent sx={{ p: { xs: 2, md: 3 } }}>
            <Box display="flex" alignItems="center" mb={2} flexDirection={{ xs: 'column', sm: 'row' }}>
              <LinkIcon sx={{ mr: { xs: 0, sm: 2 }, mb: { xs: 1, sm: 0 }, color: 'secondary.main' }} />
              <Typography 
                variant="h6" 
                component="h2"
                sx={{ fontSize: { xs: '1.125rem', md: '1.25rem' } }}
              >
                For Alumni & Members
              </Typography>
            </Box>
            <Typography 
              variant="body2" 
              color="text.secondary" 
              paragraph
              sx={{ fontSize: { xs: '0.875rem', md: '0.875rem' } }}
            >
              If you're looking to access a specific form or service, you should have received 
              a direct link from the administration. Please use that specific link to access 
              your designated form or service.
            </Typography>
            <Typography 
              variant="body2" 
              color="text.secondary" 
              paragraph
              sx={{ fontSize: { xs: '0.875rem', md: '0.875rem' } }}
            >
              Don't have a link? Please contact the BSMMUPATHALUMNI administration for assistance.
            </Typography>
          </CardContent>
        </Card>

        {/* Contact Information */}
        <Card elevation={1} sx={{ backgroundColor: '#f5f5f5' }}>
          <CardContent sx={{ p: { xs: 2, md: 3 } }}>
            <Typography 
              variant="h6" 
              component="h2" 
              gutterBottom
              sx={{ fontSize: { xs: '1.125rem', md: '1.25rem' } }}
            >
              Need Help?
            </Typography>
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ fontSize: { xs: '0.875rem', md: '0.875rem' } }}
            >
              If you're having trouble accessing your form or need assistance, 
              please contact the BSMMUPATHALUMNI administration team.
            </Typography>
          </CardContent>
        </Card>
      </Stack>

      <Box textAlign="center" mt={{ xs: 4, md: 6 }}>
        <Typography 
          variant="body2" 
          color="text.secondary" 
          paragraph
          sx={{ fontSize: { xs: '0.75rem', md: '0.875rem' } }}
        >
          © 2025 BSMMUPATHALUMNI. All rights reserved.
        </Typography>
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ fontSize: { xs: '0.7rem', md: '0.8rem' } }}
        >
          Developed by VI Tech with BDBO IT Team
        </Typography>
      </Box>
    </Container>
  );
};

export default IndexPage;
